import { GameTip } from "../Game";

export class MockTip implements GameTip {
  private static INDEX = 0;

  public id: string;
  public text = "text";
  public title = "title";

  constructor() {
    MockTip.INDEX++;
    this.id = `${MockTip.INDEX}`;
  }
}
